<script>
    export let product;
    export let reference;

    const productCardClasses = "pl-0.5 pb-0.5 items-center";
    const featuredProductCardClasses = "p-1 items-start";

    // Grab the swatch colours from the theme setting stored in <span class="hidden" data-swatches>
    const swatches = document.querySelector('[data-swatches]').getAttribute('data-swatches');
    // Convert the swatch colours (string) to an object
    let swatchObject = swatches.split(",").reduce(function(object, string, index) {
        let stringParts = string.split("/");
        if (stringParts[0] && stringParts[1]) {
            object[stringParts[0]] = stringParts[1];
        };
        return object;
    }, {});

    // Takes the colour from the product options, converts it to a format that fits how the colours are stored, then returns the hex code attached to the key.
    function convertColour(colour) {
        let newColour = colour.toLowerCase().replaceAll(" ", "-").replaceAll("/", "-");
        return swatchObject[newColour];
    };
</script>

<!-- Colours come as 'Matt Blk/Red', so for tailwind classes need to be formatted to 'matt-blk-red' -->

<div class="absolute flex bottom-0 left-0 gap-[2px] justify-start {reference === "FeaturedProductCard" ? featuredProductCardClasses : productCardClasses}">
    {#each product.optionsWithUniqueValues['Colour'] as colour, index}
        {#if index <= 3}
            <div class="h-1.5 w-1.5 rounded-full border-slate-700 border" style="background-color: {convertColour(colour)}"></div>
        {/if}
    {/each}
    {#if product.optionsWithUniqueValues['Colour'].length >= 5}
        <p class="ml-[4px] text-b5">+ {product.optionsWithUniqueValues['Colour'].length - 4}</p>
    {/if}
</div>